import * as yup from "yup";
import { MSG } from "../constants/MSG";
import { isPossiblePhoneNumber } from "react-phone-number-input";

export const addRestaurantSchema = yup.object().shape({
	name: yup.string().trim().required(MSG.REQUIRED_RESTAURANT_NAME),
	email: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL),
	mobile: yup
		.string()
		.trim()
		.required(MSG.PROVIDE_MOBILE_NUMBER)
		.test("Is Valid Phone Number", MSG.REQUIRED_PROPER_MOBILE_NUMBER, (value) =>
			isPossiblePhoneNumber(value)
		)
		.matches(
			new RegExp(
				/^\+1(?:\d{0})?[-. (]?\d{3}[-. )]?\d{3}[-. ]?\d{4}$/
				// /^\(?([0-9]{0,3})\)?[-. ]?([0-9]{0,3})[-. ]?([0-9]{10,10})$/ //NOSONAR
			),
			MSG.REQUIRED_PROPER_MOBILE_NUMBER
		),
	businessType: yup.object().required(MSG.REQUIRED_BUSINESS_TYPE),
});

export const addIntegrationSchema = yup.object().shape({
	partnership: yup.string().required(MSG.PARTNERSHIP_ID),
	Lunchbox_API_Key: yup.string().required(MSG.Lunchbox_API_Key),
	Lunchbox_URL_Endpoint: yup.string().required(MSG.Lunchbox_URL_Endpoint),
	store_number: yup.string().required(MSG.STORE_NUMBER),
	menu_id: yup.string().required(MSG.MENU_ID),
});

export const updateRestaurantNameSchema = yup.object().shape({
	name: yup.string().trim().required(MSG.REQUIRED_RESTAURANT_NAME),
});

export const updateRestaurantContactSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL),
	mobile: yup
		.string()
		.trim()
		.required(MSG.PROVIDE_MOBILE_NUMBER)
		.test("Is Valid Phone Number", MSG.REQUIRED_PROPER_MOBILE_NUMBER, (value) =>
			isPossiblePhoneNumber(value)
		),
	// .matches(
	// 	new RegExp(
	// 		/^\(?([0-9]{0,3})\)?[-. ]?([0-9]{0,3})[-. ]?([0-9]{10,10})$/ //NOSONAR
	// 	),
	// 	MSG.REQUIRED_PROPER_MOBILE_NUMBER
	// ),
});

export const approveRestaurantSchema = yup.object().shape({
	commissionRate: yup
		.number()
		.required(MSG.REQUIRED_OPA_COMMISSION)
		.min(0, MSG.REQUIRED_OPA_COMMISSION_LESS_THAN_100)
		// .matches(
		// 	new RegExp(/^(?:100|\d{1,2})(?:\.\d{1,2})?$/),
		// 	"Please enter valid percentage"
		// )
		.test(
			"Is less than 100?",
			MSG.REQUIRED_OPA_COMMISSION_LESS_THAN_100,
			(value) => value < 100
		)
		.nullable(),
	isServiceChargeAllowed: yup.boolean().nullable(),
	serviceCharge: yup
		.number(MSG.PROVIDE_VALID_SERVICE_CHARGE)
		.optional()
		.when(["isServiceChargeAllowed"], (isServiceChargeAllowed, schema) => {
			return isServiceChargeAllowed
				? schema.max(100, MSG.PROVIDE_VALID_SERVICE_CHARGE) &&
						schema.min(0, MSG.PROVIDE_VALID_SERVICE_CHARGE) &&
						schema.required(MSG.REQUIRED_SERVICE_CHARGE)
				: schema;
		})
		// .matches(
		// 	new RegExp(/^(?:100|\d{1,2})(?:\.\d{1,2})?$/),
		// 	"*Please enter valid percentage"
		// )
		// .test(
		// 	"Is positive?",
		// 	MSG.PROVIDE_VALID_SERVICE_CHARGE,
		// 	(isServiceChargeAllowed, value) =>  isServiceChargeAllowed ? (value < 100) : true
		// )
		.nullable(),
});

export const restaurantGiftsSettingsSchema = yup.object().shape({
	giftExpiry: yup
		.number()
		.integer(MSG.VOUCHER_EXPIRE_INTEGER)
		.min(1, MSG.VOUCHER_EXPIRE_MIN)
		.max(90, MSG.VOUCHER_EXPIRE_MAX)
		.required(MSG.REQUIRED_VOUCHER_EXPIRE)
		.nullable(),
	minAge: yup
		.number(MSG.MIN_AGE_INTEGER)
		.integer(MSG.MIN_AGE_INTEGER)
		.required(MSG.REQUIRED_MIN_AGE)
		.nullable(),
});

export const restaurantAccountingSettingsSchema = yup.object().shape({
	tipsStatus: yup.boolean(),
	serviceChargeStatus: yup.boolean(),
	serviceCharge: yup
		.number(MSG.PROVIDE_VALID_SERVICE_CHARGE)
		// .required(MSG.PROVIDE_VALID_SERVICE_CHARGE)
		.optional()
		.when("serviceChargeStatus", (serviceChargeStatus, schema) => {
			return serviceChargeStatus
				? schema.max(100, MSG.PROVIDE_VALID_SERVICE_CHARGE) &&
						schema.min(0, MSG.PROVIDE_VALID_SERVICE_CHARGE) &&
						schema.required(MSG.REQUIRED_SERVICE_CHARGE)
				: schema;
		})
		.nullable(),
});

export const confirmSchema = yup.object().shape({
	confirm: yup
		.string()
		.required(MSG.REQUIRED_INPUT)
		.test("match", MSG.INVALID_INPUT, (confirm) => {
			if (confirm != "" && confirm != undefined && confirm != null) {
				return confirm.toLowerCase() === "confirm";
			} else {
				return false;
			}
		})
		.nullable(),
});

export const masterAddressSchema = yup.object().shape({
	restaurant: yup.object().required(MSG.REQUIRED_MASTER_ADDRESS).nullable(),
});
